import { render, staticRenderFns } from "./recyclePic.vue?vue&type=template&id=3e9cbd7d&scoped=true&"
import script from "./recyclePic.vue?vue&type=script&lang=js&"
export * from "./recyclePic.vue?vue&type=script&lang=js&"
import style0 from "./recyclePic.vue?vue&type=style&index=0&id=3e9cbd7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9cbd7d",
  null
  
)

export default component.exports